module.exports = __webpack_public_path__ + "img/open_ended.196e6c65.svg";